module.exports = __webpack_public_path__ + "img/open_project_orange.da24ec33.svg";